import { useCallback, useState } from 'react';

export const useStartingRatesState = () => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [firstAccordionRowIsOpen, setFirstAccordionRowIsOpen] = useState(true);

  const handleCategorySelect = useCallback((index: number) => {
    setSelectedIndex(index);
  }, []);

  const toggleFirstAccordion = useCallback(() => {
    setFirstAccordionRowIsOpen((prev) => !prev);
  }, []);

  return {
    selectedIndex,
    setSelectedIndex,
    firstAccordionRowIsOpen,
    handleCategorySelect,
    toggleFirstAccordion,
  };
};
